import React from 'react'
import { Popover, Box, Typography, IconButton, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useHelp } from './HelpProvider'

interface FormHelpPopoverProps {
  anchorEl: HTMLElement | null
  steps: { title: string; description: string }[]
  stepIndex: number
}

const FormHelpPopover: React.FC<FormHelpPopoverProps> = ({ anchorEl, steps, stepIndex: _stepIndex }) => {
  const { currentStep, nextStep: _nextStep, prevStep, stopHelp } = useHelp()

  const theme = useTheme()
  const isOpen = Boolean(anchorEl) && currentStep !== null && currentStep < steps.length
  if (currentStep === null) return null

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={stopHelp}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      slotProps={{
        paper: {
          sx: {
            p: 2,
            mt: 1,
            width: 320,
            backgroundColor: 'background.help',
            // backgroundColor: 'transparent',
            backdropFilter: 'blur(15px)',
            borderRadius: 2,
            boxShadow: theme.shadows[6],
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              width: 0,
              height: 0,
              borderLeft: '10px solid transparent',
              borderRight: '10px solid transparent',
              borderBottom: theme => `10px solid ${theme.palette.background.paper}`,
              top: 0,
              left: 'calc(50% - 10px)',
            },
          },
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" fontWeight="bold" color="text.success" fontSize={22}>
          {steps[currentStep]?.title}
        </Typography>
        <IconButton size="small" onClick={stopHelp}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      {typeof steps[currentStep]?.description === 'string' ? (
        <Typography sx={{ mt: 1, fontSize: 18 }}>{steps[currentStep]?.description}</Typography>
      ) : (
        steps[currentStep]?.description
      )}
    </Popover>
    // <Popover
    //   open={isOpen}
    //   anchorReference="anchorPosition"
    //   anchorPosition={{ top: 250, left: 600 }} // tweak these values as needed
    //   onClose={stopHelp}
    //   PaperProps={{
    //     sx: {
    //       width: 320,
    //       p: 2,
    //       borderRadius: 2,
    //       boxShadow: theme.shadows[6],
    //       backgroundColor: 'background.help',
    //       backdropFilter: 'blur(15px)',
    //     },
    //   }}
    // >
    //   <Box display="flex" justifyContent="space-between" alignItems="center">
    //     <Typography variant="subtitle1" fontWeight="bold" color="text.success" fontSize={22}>
    //       {steps[currentStep]?.title}
    //     </Typography>
    //     <IconButton size="small" onClick={stopHelp}>
    //       <CloseIcon fontSize="small" />
    //     </IconButton>
    //   </Box>
    //   {typeof steps[currentStep]?.description === 'string' ? (
    //     <Typography sx={{ mt: 1, fontSize: 18 }}>{steps[currentStep]?.description}</Typography>
    //   ) : (
    //     steps[currentStep]?.description
    //   )}
    // </Popover>
  )
}

export default FormHelpPopover
